// extracted by mini-css-extract-plugin
module.exports = {"formContainer":"styles_formContainer__1oqjA","formRow":"styles_formRow__1uwPF","formCol":"styles_formCol__1MIUj","buttonsWrapper":"styles_buttonsWrapper__2NEmu"};